export const EMAIL_REGEX = /\S+@\S+\.\S+/;

export const COORDINATES_REGEX = /^(?<lat>\d+(?:(\.|,)\d*)?)s*(,|;)\s*(?<lon>\d+(?:(\.|,)\d*)?)$/;
